export default __webpack_public_path__ + "static/media/filter.ac1b0dbe.svg";